import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://kmnrofueawqeisiclnpj.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    storageKey: 'charlie.auth.token',
  },
});

// v1.6.41: Session refresh guard. If a refresh fails (network blip, revoked token),
// signOut cleanly so the app can re-auth instead of returning null rows silently.
if (typeof window !== 'undefined') {
  supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'TOKEN_REFRESHED') {
      // Refresh succeeded, nothing to do.
    } else if (event === 'SIGNED_OUT') {
      // Clear any cached data to prevent stale-state crashes.
      try { window.localStorage.removeItem('charlie_active_partner_id'); } catch (_) {}
    }
  });

  // Proactively probe session on load; if refresh fails, mark it so callers can react.
  supabase.auth.getSession().then(({ data, error }) => {
    if (error) {
      // eslint-disable-next-line no-console
      console.warn('[charlie] session probe failed:', error.message);
    }
  }).catch(() => {});
}
